
import { apiGet, apiPost, apiPut, apiDelete, apiPatch } from "../utils/axios";
import { domainUrl } from "../utils/domainUrls";

export default {
  // Create a new script
  createScript: (payload) => apiPost(domainUrl(`/v1/script`), payload),
  
  // Get all scripts with pagination
  getScripts: (size = 50, current = 1, searchInput="", sortColumn="", status="") => apiGet(domainUrl(`/v1/script?limit=${size}&page=${current}&scriptTitle=${searchInput}&sortBy=${sortColumn}&status=${status}`)),

  // get scripts for physicians
  getMyScript: () => apiGet(domainUrl(`/v1/script/get/my-script`)),
  
  // Get a specific script by ID
  getScript: (id) => apiGet(domainUrl(`/v1/script/${id}`)),
  
  // Update an existing script
  updateScript: (id, payload) => apiPut(domainUrl(`/v1/script/${id}`), payload),
  
  // Delete a script
  deleteScript: (id) => apiDelete(domainUrl(`/v1/script/${id}`)),

  // Assign Script to board member
  assignBoardMember: (payload) => apiPatch(domainUrl(`/v1/script/assign-board-member`), payload),

  // Approve and Reject Script
  scriptApproveOrReject: (id, payload) => apiPatch(domainUrl(`/v1/script/${id}/approve-or-reject`), payload),

  // Approve and Reject Script
  assignScriptToPhysician: (payload) => apiPost(domainUrl(`/v1/script/assign-physician`), payload),
  generateScriptWithAi: ( payload) => apiPost(domainUrl(`/v1/script/generate`), payload),
  optimizeScriptWithAi: ( payload) => apiPost(domainUrl(`/v1/script/optimize-script-generate`), payload),

};